<template>
    <component
        :is="isModal ? AmsTooltipModal : AmsTooltipPopover"
        v-slot="{ isActive }"
        :tooltip="tooltip"
        :position="position"
        :showOnHover="showOnHover"
    >
        <slot :isActive="isActive" />
    </component>
</template>
<script lang="ts" setup>
import AmsTooltipPopover from './AmsTooltipPopover.vue'
import AmsTooltipModal from './AmsTooltipModal.vue'
import { isTouchDevice } from '../../utils/clientUtils/isTouchDevice'
import { Components } from '@sunrise/types'
import { Tooltip } from './AmsTooltip.interface'
import { onMounted, ref } from 'vue'

const isModal = ref(true)

onMounted(() => {
    isModal.value = isTouchDevice()
})

interface Props {
    tooltip: Tooltip
    position?: Components.CsTooltip.TooltipPosition
    showOnHover?: boolean
}

withDefaults(defineProps<Props>(), {
    showOnHover: true,
})
</script>
